import { FormInput, SelectInput } from '@policoders/ds';

import { IProductFormProps, useProductForm } from './product.form.hook';

const ProductForm = ({ data, onChange }: IProductFormProps) => {
  const { state, measureUnitTypes, handleChange } = useProductForm({ data, onChange });

  return (
    <div>
      <div className="row">
        <div className="col-sm-4 col-lg-2">
          <FormInput
            type="text"
            label="Código"
            field="productCode"
            value={state.productCode}
            disabled={state.productCode === '0'}
            onChange={handleChange}
          />
        </div>
        <div className="col-sm-8 col-lg-4">
          <FormInput
            type="text"
            label="Descrição"
            field="productName"
            value={state.productName}
            onChange={handleChange}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <FormInput
            type="number"
            label="Unidade"
            field="unit"
            value={state.unit}
            onChange={handleChange}
          />
        </div>
        <div className="col-6 col-sm-4 col-lg-2">
          <SelectInput
            label="Unid. medida"
            field="measureUnit"
            value={state.measureUnit}
            options={measureUnitTypes()}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-4 col-lg-2">
          <FormInput
            type="number"
            label="Últ. preço"
            field="lastPurchasePrice"
            value={state.lastPurchasePrice}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductForm;
